import { render } from "./FoundItems.vue?vue&type=template&id=6d2466ea"
import script from "./FoundItems.vue?vue&type=script&lang=js"
export * from "./FoundItems.vue?vue&type=script&lang=js"

import "./FoundItems.vue?vue&type=style&index=0&id=6d2466ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__